import React, { useState } from "react";
import "../../assets/css/intern-profile-view.css";

import NavBar from "../../components/general/NavBarApp.jsx";
import InternProfileView from "../../components/intern/internProfileView";
import NavBarApp from "../../components/general/NavBarApp.jsx";

const InternProfile = () => {
  return (
    <div className="main">
      <NavBarApp userType="entreprise" />
      <InternProfileView />
    </div>
  );
};

export default InternProfile;
